<template>
    <svg :class="className"  width="18" height="17" viewBox="0 0 18 17" fill="none">
        <path d="M17.2187 8.00006C17.2187 5.9544 16.4516 3.9818 15.0818 2.48408L16.269 0.219238L9.45619 0.52974L13.1274
            6.28316L14.0955 4.42015C14.8261 5.46125 15.2461 6.70326 15.2461 8.00006C15.2461 11.4338 12.4516 14.2284
            9.01784 14.2284C5.58405 14.2284 2.78953 11.4338 2.78953 8.00006C2.78953 5.60736 4.12286 3.45211 6.27811
            2.41102L6.80779 2.15531L5.93108 0.365357L5.4014 0.621064C2.55208 2.00919 0.780395 4.84024 0.780395 8.00006
            C0.780395 12.5297 4.46989 16.2192 8.99957 16.2192C13.5293 16.2192 17.2187 12.5297 17.2187 8.00006Z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
